import axios from "axios";
import Config from "../../../config";

const v2_actionListarCustomTabs = (clienteId, pipelineId) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/crm/custom-tabs?pipeline_id=${pipelineId}`
    });
};

export default v2_actionListarCustomTabs;
